import { useStores } from "@nanostores/lit";
import { html, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { computed } from "nanostores";
import { shortlist } from "./ac101-app";
import { BaseElement } from "./BaseElement";

const shortlistCount = computed(shortlist, (shortlist) => shortlist.length);
shortlistCount.subscribe((x) => console.log({ x }));

@customElement("ac101-shortlist-count")
@useStores(shortlistCount)
export class AC101ShortlistCount extends BaseElement {
  render() {
    if (shortlistCount.get() === 0) return html``;
    return html`<span class="shortlist-length">${shortlistCount.get()}</span>`;
  }
}
